// eslint-disable-next-line max-classes-per-file
class ExtendableError extends Error {
  constructor(message = '') {
    super(message);

    // extending Error is weird and does not propagate `message`
    Object.defineProperty(this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true,
    });

    Object.defineProperty(this, 'name', {
      configurable: true,
      enumerable: false,
      value: this.constructor.name,
      writable: true,
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(this, this.constructor);
      return;
    }

    Object.defineProperty(this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true,
    });
  }
}

class AppError extends ExtendableError {
  constructor(message, code, type, data) {
    super(message);
    this.code = code || 500;
    this.type = type;
    this.data = data;
    this.retryable = false;
  }
}

class RetryableAppError extends AppError {
  constructor(message, code, type, data) {
    super(message);
    this.code = code || 500;
    this.type = type;
    this.data = data;
    this.retryable = true;
  }
}

export default AppError;

export { RetryableAppError, AppError };
